export default function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
// module id = 318
// module chunks = 0